import { Children } from 'react';
import SimpleNavigationDesktop from '@features/navigation/components/SimpleNavigation/SimpleNavigationDesktop';
import SimpleFooter from '@features/footer/SimpleFooter';
import styles from '@features/layout/components/Layout/components/SimpleLayout/SimpleLayout.styles';
import Alerts from '@components/Alerts/Alerts';
import SimpleNavigationMobile from '@features/navigation/components/SimpleNavigation/SimpleNavigationMobile';
import Popups from '@components/Popups/Popups';
type PropsType = {
  children: React.ReactNode;
  attachFirstChildToNavigation?: boolean;
  overflowY?: string;
  overflowX?: string;
};
const SimpleLayout = ({
  children,
  attachFirstChildToNavigation = false,
  overflowY = 'auto',
  overflowX = 'hidden'
}: PropsType) => {
  const arrayChildren = Children.toArray(children);
  const arrayChildrenWithoutFirstElement = Children.toArray(children);
  arrayChildrenWithoutFirstElement.shift();
  return <div sx={styles.container(overflowY, overflowX)}>
      {attachFirstChildToNavigation && <>
          <div>
            <SimpleNavigationMobile />
            <SimpleNavigationDesktop />
            {arrayChildren[0]}
          </div>
          {arrayChildrenWithoutFirstElement}
        </>}

      {!attachFirstChildToNavigation && <>
          <SimpleNavigationMobile />
          <SimpleNavigationDesktop />
          {children}
        </>}
      <Alerts />
      <Popups />
      <SimpleFooter />
    </div>;
};
export default SimpleLayout;